// eslint-disable-next-line no-redeclare
/* global window */

const ga4Events = {
    /**
     * Fire add_to_cart event
     */
    addToCart() {
        $('body').on('product:afterAddToCart', (e, data) => {
            if (!data || !data.cart) {
                return;
            }

            const lastItem = data.cart.items && data.cart.items.length
                ? data.cart.items[data.cart.items.length - 1]
                : null;

            if (!lastItem) {
                return;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    currency: (lastItem.price && lastItem.price.sales && lastItem.price.sales.currency)
                        ? lastItem.price.sales.currency
                        : 'USD',
                    value: (lastItem.price && lastItem.price.sales)
                        ? lastItem.price.sales.value
                        : 0,
                    items: [{
                        item_id: lastItem.id,
                        item_name: lastItem.productName,
                        price: (lastItem.price && lastItem.price.sales)
                            ? lastItem.price.sales.value
                            : 0,
                        quantity: lastItem.quantity || 1,
                    }],
                },
            });
        });
    },

    /**
     * Fire begin_checkout event
     */
    beginCheckout() {
        $('body').on('checkout:begin', (e, data) => {
            if (!data || !data.order) {
                return;
            }

            const items = [];
            data.order.items.items.forEach((item) => {
                items.push({
                    item_id: item.id,
                    item_name: item.productName,
                    price: (item.price && item.price.sales)
                        ? item.price.sales.value
                        : 0,
                    quantity: item.quantity || 1,
                });
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'begin_checkout',
                ecommerce: {
                    currency: (data.order.totals.rawValues)
                        ? 'USD'
                        : 'USD',
                    value: (data.order.totals.rawValues && data.order.totals.rawValues.orderTotal)
                        ? data.order.totals.rawValues.orderTotal
                        : 0,
                    items,
                },
            });
        });
    },

    /**
     * Initialize all GA4 events
     */
    init() {
        this.addToCart();
        this.beginCheckout();
    },
};

module.exports = ga4Events;
